import axios from 'axios'
import { IhLogUrl } from '@/api/config'
import { errorCollection } from '@/api/dmp/dmpCollection'

/**
 * 查询gps轨迹详情
 * @param {*} userId 用户id
 * @param {*} logId  记录id
 */
export function listGpsDetail(userId, logId) {
  const url = IhLogUrl + `/gps/trace/${userId}/${logId}`

  return axios({
    method: 'get',
    url: url,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('实时监控', '查询gps轨迹详情', res)
    }
    return Promise.resolve(res.data)
  })
}
